import React from 'react';
import styles from './IndustryCards.module.css';
import { FaTerminal } from 'react-icons/fa';
import { isSmallScreen } from '../../../utils/screen';

interface IndustryCardsProps {
    title: React.ReactNode;
    cards: Array<{
        text: React.ReactNode;
    }>;
}

const IndustryCards: React.FC<IndustryCardsProps> = ({ title, cards }) => {
    return (
        <section className={styles.section}>
            <div className={styles.header}>
                <FaTerminal size={isSmallScreen() ? 44 : 54} />
                <h2 className={styles.title}>{title}</h2>
            </div>
            <div className={styles.cardsContainer}>
                {cards.map((card, index) => (
                    <div key={index} className={styles.card}>
                        <p className={styles.cardDescription}>{card.text}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default IndustryCards; 